import EmployeeProfileSection from './EmployeeProfileSection';
import SkillsSection from './SkillsSection';
import TeamMembersSection from './TeamMembersSection';
import PeerPointsSection from './PeerPointsSection';
import type { TeamMember } from './TeamMembersSection';
import type { Skill } from './SkillsSection';

interface MonthlyBreakdown {
    month: number;
    year: number;
    points_given: number;
    points_earned: number;
}

interface LeftSidebarProps {
    employeeName: string;
    designation?: string;
    imageUrl?: string;
    employeeLoading: boolean;
    employeeError: any;
    skills: Skill[];
    skillsLoading: boolean;
    skillsError: any;
    teamMembers: TeamMember[];
    teamMembersLoading: boolean;
    teamMembersError: any;
    peerPoints: {
        received: number;
        given: number;
        monthlyBreakdown: MonthlyBreakdown[];
    };
    peerPointsLoading: boolean;
    peerPointsError: any;
    employeeOptions: Array<{ key: number; name: string }>;
    selectedEmployeeName: string;
    onEmployeeSelect: (employeeId: number, employeeName: string) => void;
    employeesLoading: boolean;
}

const LeftSidebar = ({ 
    employeeName, 
    designation, 
    imageUrl, 
    employeeLoading, 
    employeeError, 
    skills, 
    skillsLoading, 
    skillsError, 
    teamMembers, 
    teamMembersLoading, 
    teamMembersError, 
    peerPoints,
    peerPointsLoading,
    peerPointsError,
    employeeOptions,
    selectedEmployeeName,
    onEmployeeSelect,
    employeesLoading
}: LeftSidebarProps) => {
    return (
        <div className="w-[360px] mq991:w-full flex flex-col gap-6 inner_leftsidebar-userprofile">
            <EmployeeProfileSection 
                employeeName={employeeName} 
                designation={designation} 
                imageUrl={imageUrl}
                loading={employeeLoading}
                error={employeeError}
                employeeOptions={employeeOptions}
                selectedEmployeeName={selectedEmployeeName}
                onEmployeeSelect={onEmployeeSelect}
                employeesLoading={employeesLoading}
            />
            <SkillsSection 
                skills={skills} 
                loading={skillsLoading}
                error={skillsError}
            />
            <TeamMembersSection 
                teamMembers={teamMembers} 
                loading={teamMembersLoading}
                error={teamMembersError}
            />
            <PeerPointsSection 
                received={peerPoints.received} 
                given={peerPoints.given}
                monthlyBreakdown={peerPoints.monthlyBreakdown}
                loading={peerPointsLoading}
                error={peerPointsError}
            />
        </div>
    );
};

export default LeftSidebar;
